// Data/Forms/Inventory/Adjustments/headers.js
const headers = {
    name: "Inventory Adjustment",
    components: [
        {
            type: "search",
            name: "search",
            placeholder: "Search",
            value: "",
        },
        {
            type: "select",
            name: "sort",
            placeholder: "Sort",
            value: null,
            options: [
                { value: "1", label: "Date (Newest)" },
                { value: "2", label: "Date (Oldest)" },
                { value: "3", label: "Quantity (Low)" },
                { value: "4", label: "Quantity (High)" },
            ],
        },
        {
            type: "filter",
            name: "type",
            placeholder: "Type",
            value: null,
            options: [
                { value: "damage", label: "Damage" },
                { value: "wastage", label: "Wastage" },
                { value: "expired", label: "Expired" },
                { value: "return", label: "Return" },
            ],
        },
        {
            type: "filter",
            name: "status",
            placeholder: "Status",
            value: null,
            options: [
                { value: 0, label: "Inactive" },
                { value: 1, label: "Active" },
            ],
        },
        {
            type: "range",
            name: "date",
            value: {
                start: "",
                end: "",
            },
        },
        {
            type: "add",
            path: "/app/inventory/adjustment/add",
        },
    ],
    navigate: {
        tabs: [
            {
                name: "Batch",
                path: "/app/inventory",
            },
            {
                name: "Transfer",
                path: "/app/inventory/transfer",
                featureKey: "inventory_transfer_receive",
            },
            {
                name: "Received",
                path: "/app/inventory/received",
                featureKey: "inventory_transfer_receive",
            },
            {
                name: "Request",
                path: "/app/inventory/request",
                featureKey: "inventory_request",
            },
            {
                name: "Requested",
                path: "/app/inventory/requested",
                featureKey: "inventory_request",
            },
            {
                name: "Adjustment",
                path: "",
                featureKey: "inventory_adjustment",
            },
            {
                name: "Sites",
                path: "/app/inventory/sites"
            }
        ],
        total: [
            { value: "0", label: "Total" },
            { value: "0", label: "Damage" },
            { value: "0", label: "Wastage" },
            { value: "0", label: "Expired" },
            { value: "0", label: "Return" },
        ],
    },
};

export default headers;